import { createSlice } from "@reduxjs/toolkit";
import { getAbbreviation } from "../utils/_helpers";

const initialState = {
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveUser: (state, action) => {
      const { user, data } = action.payload;
      const abbreviation = getAbbreviation(
        `${user?.first_name}-${user?.last_name}`
      );
      const userWithPermissions = { ...user, permissions: data, abbreviation };
      state.user = userWithPermissions;
    },
    logout: (state) => {
      state.user = null;
      localStorage.removeItem("token");
    },
  },
});

export const { saveUser, logout } = authSlice.actions;
export default authSlice.reducer;
